import { Injectable, inject } from '@angular/core';
import { UrlTree, Router } from '@angular/router';
import { UserFacade } from '@app/store/user';
import { Observable, map, take } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class UserLoggedInGuard {
    private readonly userFacade = inject(UserFacade);
    private readonly router = inject(Router);

    canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this.userFacade.loaded$.pipe(
            take(1),
            map((loaded) => {
                if (loaded === false) {
                    return this.router.createUrlTree(['/auth/sign-in']);
                }
                return true;
            }),
        );
    }
}
